// @ts-nocheck
import Axios from "axios";
import tokenUtil from '@/utils/TokenUtil';
export default {
    //get请求
    async apiUtilGet(url,obj) :any{
        return(await Axios.get(url,{params:{...obj}, headers: { 'Authorization': tokenUtil.getToken() } }));
    },
    //get请求
    async apiUtilGetUrl(url) :any{
        return(await Axios.get(url,{headers: { 'Authorization': tokenUtil.getToken() }}));
    },

    //post请求
    async apiUtilPost(url,obj) :any{
        return (await Axios.post(url,{...obj},{headers: { 'Authorization': tokenUtil.getToken() }}));
    },
    //post请求
    async apiUtilPostNoParam(url) :any{
        return (await Axios.post(url,null,{headers: { 'Authorization': tokenUtil.getToken() }}));
    },
    //postForm请求
    async apiUtilPostForm(url,FormData) :any{
        return (await Axios.post(url,FormData,{headers: { 'Authorization': tokenUtil.getToken() }}));
    },
    async apiUtilPostArray(url,obj){
        return (await Axios.post(url,obj,{headers: { 'Authorization': tokenUtil.getToken() }})).data;
    },
    //get请求
    async apiUtilPutUrl(url) :any{
        return(await Axios.put(url,null,{headers: { 'Authorization': tokenUtil.getToken() }}));
    },
}
